module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_6.5f1e00d8.png";